import { InputHTMLAttributes, forwardRef } from 'react';

type TextInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

const TextInput = forwardRef<HTMLInputElement, TextInputProps>((props, ref) => (
    <input
        ref={ref}
        className="border border-gray-300 rounded py-2 px-3 text-grey-800 bg-gray-100"
        type="text"
        {...props}
    />
));

TextInput.displayName = 'TextInput';

export default TextInput;